import { data } from 'jquery';
import ScrollReveal from './ScrollReveal';

class Counter extends ScrollReveal {
  duration: number;

  constructor($targets = $()) {
    super($targets);

    this.duration = 2000;

    this.prepare();
  }

  prepare() {
    this.$targets.each((index, element) => {
      const $target = $(element);
      $target.css('min-width', $target.width()!);
      $target.text('0');
    });
  }

  animateIn(target?: HTMLElement | undefined): void {
    super.animateIn();
    if (!target) return;
    this.animateNumber(target);
  }

  animateNumber(element: HTMLElement) {
    let startTimestamp: number;
    let target = +element.dataset.target!;

    const step = (timestamp: number) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min(
        (timestamp - startTimestamp) / this.duration,
        1,
      );
      element.innerHTML = Math.floor(progress * target).toString();
      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };

    window.requestAnimationFrame(step);
  }

  onResize() {
    // reset min width
    this.$targets.each((index, element) => {
      const $target = $(element);
      $target.css('min-width', '');
    });

    // re-prepare
    this.prepare();
  }
}

export default Counter;
